import React from "react";

function LockIconBleu() {
  return (
    <svg
      width="87"
      height="87"
      viewBox="0 0 87 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="7.17773"
        y="7.17773"
        width="72"
        height="72"
        rx="36"
        fill="#E3F2FD"
      />
      <rect
        x="7.17773"
        y="7.17773"
        width="72"
        height="72"
        rx="36"
        stroke="#EEF8FF"
        strokeWidth="14.3551"
      />
      <path
        d="M31.9484 51.9709C32.2831 54.457 34.3422 56.4045 36.8479 56.5197C38.9563 56.6166 41.0982 56.6672 43.4568 56.6672C45.8154 56.6672 47.9572 56.6166 50.0656 56.5197C52.5714 56.4045 54.6304 54.457 54.9652 51.9709C55.1837 50.3486 55.3638 48.6859 55.3638 46.9928C55.3638 45.2996 55.1837 43.6369 54.9652 42.0146C54.6304 39.5286 52.5714 37.581 50.0656 37.4658C47.9572 37.3689 45.8154 37.3184 43.4568 37.3184C41.0982 37.3184 38.9563 37.3689 36.8479 37.4658C34.3422 37.581 32.2831 39.5286 31.9484 42.0146C31.73 43.6369 31.5498 45.2996 31.5498 46.9928C31.5498 48.6859 31.73 50.3486 31.9484 51.9709Z"
        stroke="#4072C8"
        strokeWidth="3.36449"
      />
      <path
        d="M36.7598 37.318V33.5971C36.7598 29.8981 39.7584 26.8994 43.4574 26.8994C47.1565 26.8994 50.1551 29.8981 50.1551 33.5971V37.318"
        stroke="#4072C8"
        strokeWidth="3.36449"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.4102 46.9775V46.9924"
        stroke="#4072C8"
        strokeWidth="3.50903"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.457 46.9775V46.9924"
        stroke="#4072C8"
        strokeWidth="3.50903"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5039 46.9775V46.9924"
        stroke="#4072C8"
        strokeWidth="3.50903"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LockIconBleu;
